import React from "react"
import classNames from "classnames"
import { Hint } from "./Hint"
import { FormElement } from "./form"

type Position = "left" | "right"

type Props = {
  large?: boolean | undefined
  label?: string
  position?: Position
  hint?: string
} & FormElement &
  React.InputHTMLAttributes<HTMLInputElement>

const ToggleSwitch = ({
  large,
  status,
  label,
  position,
  hint,
  ...inputProps
}: Props) => {
  return (
    <div
      className={classNames("cobalt-ToggleSwitchField", {
        "cobalt-ToggleSwitchField--large": large,
        "cobalt-ToggleSwitchField--position-left": position === "left",
        "cobalt-ToggleSwitchField--error": status === "error",
        "cobalt-ToggleSwitchField--standalone": !label,
      })}
    >
      <label className="cobalt-ToggleSwitchField__LabelWrapper">
        <input
          {...inputProps}
          type="checkbox"
          className="cobalt-ToggleSwitchField__Input"
        />
        <span className="cobalt-ToggleSwitchField__ToggleSwitch">
          <span className="cobalt-ToggleSwitchField__ToggleSwitchSlider" />
        </span>

        {label && (
          <span className="cobalt-ToggleSwitchField__Label">{label}</span>
        )}
      </label>
      {hint && (
        <Hint status={status}>
          <span dangerouslySetInnerHTML={{ __html: hint }} />
        </Hint>
      )}
    </div>
  )
}

export { ToggleSwitch }
